export const CUSTOMER_TAGS_FIELD_NAME = 'tags';
